import { Menu, MenuProps } from "antd";
import { ItemType } from "antd/es/menu/hooks/useItems";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

type MenuItem = Required<MenuProps>["items"][number];

export type MenuItemType = MenuItem & {
  path: string;
  children?: MenuItemType[];
};
export interface ISelectedPageContainerProps extends MenuProps {
  items: MenuItemType[];
}

export const SelectedPageContainer = ({
  items,
}: ISelectedPageContainerProps) => {
  const [menuItems, setMenuItems] = useState<ItemType[]>([]);
  const [isItemSelected, setIsItemSelected] = useState<boolean>(false);
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const navigate = useNavigate();
  const location = useLocation();

  const matchingUrlPatterns = [/(browse.*)/, /(search.*)/, /(upload.*)/];

  const menuBuilder = (menuList: MenuItemType[]): ItemType[] => {
    return menuList.map((item: MenuItemType) => {
      const menuItem = {
        ...item,
        children: item.children ? menuBuilder(item.children) : undefined,
        onClick: () => {
          navigate(item.path);
          setSelectedKeys(item.key ? [item.key.toString()] : []);
        },
      };

      return menuItem;
    });
  };

  const whichUrlMatching = (pathName: string): number => {
    for (let i = 0; i < items.length; i++) {
      if (matchingUrlPatterns[i].test(pathName)) {
        return i;
      }
    }
    return -1;
  };

  const updateSelectedKeys = () => {
    const urlMatching = whichUrlMatching(location.pathname);
    if (urlMatching !== -1) {
      setSelectedKeys([String(items[urlMatching].key)]);
    } else {
      setIsItemSelected(false);
    }
  };

  useEffect(() => {
    setMenuItems(menuBuilder(items));
    updateSelectedKeys();
  }, []);

  useEffect(() => {
    if (selectedKeys[0] !== undefined) {
      setIsItemSelected(true);
    }
  }, [selectedKeys])

  useEffect(() => {
    updateSelectedKeys();
  }, [location]);

  return (
    <Menu
      selectedKeys={isItemSelected ? selectedKeys : []}
      mode="horizontal"
      items={menuItems}
      style={{
        minWidth: "300px",
        width: "200%",
        fontSize: "20px",
        fontWeight: 500,
        backgroundColor: "white",
        border: "none",
      }}
    ></Menu>
  );
};
